export default class MultiSelectModel {
  constructor(
    public id: any,
    public text: string,
    public disabled: boolean = false,
    public canRemoveChip: boolean = true
  ) {
    this.id = id;
    this.text = text;
    this.disabled = disabled;
    this.canRemoveChip = canRemoveChip;
  }

  static initModel = () => {
    return new MultiSelectModel("", "");
  };
}
